import React, { Component } from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';

const select = state => {
  return {
    token: state.auth.token,
  };
};

class ConnectedProgramsComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      virtualPrograms: []
    };
  }

  async componentDidMount() {

    const { token } = this.props;

    const fecthPrograms = fetch(`${apiUrl}/admin/programs?token=${token}`);
    const respPrograms = await fecthPrograms;
    const data = await respPrograms.json();

    if (data.success) {
      this.setState({
        virtualPrograms: data.virtualPrograms
      });
    }

    this.setState({ isLoading: false });
  }

  render() {

    const { virtualPrograms, isLoading } = this.state;

    if (isLoading) return (<AppSpinner />);

    return (
      <div className="table-info-component foundations-component">
        <Container>
          <Row>

            <Col xs={12}>
              <h4 className="title">Voluntariados digitales</h4>

              <Table striped bordered hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>Fundación</th>
                    <th>Aplicantes aceptados</th>
                    <th>Aplicantes total</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    virtualPrograms.map((program, index) =>
                        <tr key={program._id}>
                          <td>{index + 1}</td>
                          <td>{program.name}</td>
                          <td>{program.foundationName}</td>
                          <td>{program.users.filter(user => user.accepted).length}</td>
                          <td>{program.users.length}</td>
                        </tr>
                    )
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const ProgramsComponent = connect(select)(ConnectedProgramsComponent);

export default ProgramsComponent;
